/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_NavigateInputs */

const en_hero_navigate = /** @type {(inputs: Hero_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navigate`)
};

const ar_hero_navigate = /** @type {(inputs: Hero_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنقّل`)
};

const bn_hero_navigate = /** @type {(inputs: Hero_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নেভিগেট`)
};

const de_hero_navigate = /** @type {(inputs: Hero_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation`)
};

const es_hero_navigate = /** @type {(inputs: Hero_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navegar`)
};

const fr_hero_navigate = /** @type {(inputs: Hero_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`naviguer`)
};

const pt_hero_navigate = /** @type {(inputs: Hero_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navegar`)
};

const zh_hero_navigate = /** @type {(inputs: Hero_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导航`)
};

const tr_hero_navigate = /** @type {(inputs: Hero_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gezin`)
};

const ru_hero_navigate = /** @type {(inputs: Hero_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`перейти`)
};

const pl_hero_navigate = /** @type {(inputs: Hero_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nawiguj`)
};

/**
* | output |
* | --- |
* | "navigate" |
*
* @param {Hero_NavigateInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_navigate = /** @type {((inputs?: Hero_NavigateInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_NavigateInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_hero_navigate(inputs)
	if (locale === "bn") return bn_hero_navigate(inputs)
	if (locale === "de") return de_hero_navigate(inputs)
	if (locale === "es") return es_hero_navigate(inputs)
	if (locale === "fr") return fr_hero_navigate(inputs)
	if (locale === "pt") return pt_hero_navigate(inputs)
	if (locale === "zh") return zh_hero_navigate(inputs)
	if (locale === "tr") return tr_hero_navigate(inputs)
	if (locale === "ru") return ru_hero_navigate(inputs)
	if (locale === "pl") return pl_hero_navigate(inputs)
	return en_hero_navigate(inputs)
});